export default __webpack_public_path__ + "static/RevitalizationPlanningAndPrograms-194a0b899ac43a8a179794f526c378dd.jpg";